var isOnCollectionPageAndFirstTimeLoaded = true;

const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};

replaceTemplate("wizzy-autocomplete-topproducts");
replaceTemplate("wizzy-search-results-product");
replaceTemplate("wizzy-search-sort");
replaceTemplate("wizzy-search-summary");
replaceTemplate("wizzy-search-empty-results");
replaceTemplate("wizzy-search-wrapper");
replaceTemplate("wizzy-search-pagination");

var searchIcon = document.querySelector(".t4s-site-nav__search a");
if (searchIcon) {
  // alert("inside search icon")
  console.log("inside search icon");
  searchIcon.addEventListener("click", function () {
    var searchBar = document.querySelector(".wizzy-search");
    if (searchBar) {
      console.log("inside search bar");
      setTimeout(function () {
        // console.log("Now setTimeout is executing")
        console.log("search bar");
         $('.wizzy-search-popup-container').attr('show', 'true');
        searchBar?.focus();
        searchBar?.click();
      }, 100);
    }
  });
}

     

      $(document).on('click', '.t4s-drawer__close', function() {
  $('.wizzy-search-popup-container').attr('show', 'false');
});
// var form = document.querySelector(".wizzy-search-form");
// form.addEventListener('submit', function (e) {
//   if(window.location.href.split("/").includes("collections")){
//     e.preventDefault();
//     window.location.href = window.location.origin + '/pages/search?q=' + document.querySelector(".wizzy-search.wizzy-search-input").value;
//   }
// })

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      data["filters"]["configs"]["keepOpenedInMobileAfterApply"] = true;
      window.wizzyConfig.search.view.templates.facets.rangeListItem =
        "#wizzy-facet-range-list-item";
      window.wizzyConfig["search"]["configs"]["pagination"]["type"] =
        "numbered";

      if (data?.common?.isOnCategoryPage) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#wizzy-shopify-collection-page-container",
        ];
      } else {
        wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#MainContent",
        ];
      }

      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push(
        ".main-content"
      );

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      var fullUrl = window.location.pathname + window.location.search;
      var urlParams = new URLSearchParams(window.location.search);
      // console.log(urlParams);
      var page = parseInt(urlParams.get("page"), 10) || 1;
      page = parseInt(page);
      // console.log(page);
      // console.log(page);
      // console.log("Full URL:", fullUrl);
      var allowedUrls = [
        "/collections/shop-all?page=2",
        "/collections/shop-all?page=3",
        "/blogs/post?page=2",
        "/collections/kitchen-dining?type=default",
        "/collections/candle-holders?type=default",
        "/collections/bath-more?type=default",
        "/collections/table-accessories?type=default",
        "/collections/candle-stands?type=default",
      ];

      var isMatch = allowedUrls.some(function (url) {
        return fullUrl.includes(url);
      });

      var metaTag = document.querySelector('meta[name="robots"]');

      // console.log(isMatch);

      if (isMatch) {
        metaTag.setAttribute("content", "noindex, follow");
      } else if (parseInt(page) <= 10) {
        // console.log("HII");
        metaTag.setAttribute("content", "index,follow");
      } else {
        metaTag.setAttribute("content", "noindex,follow");
      }

      console.log("before_init");
      data["filters"]["configs"]["keepOpenedInMobileAfterApply"] = true;
      window.wizzyConfig.search.view.templates.facets.rangeListItem =
        "#wizzy-facet-range-list-item";
      window.wizzyConfig["search"]["configs"]["pagination"]["type"] =
        "numbered";
      if (data.common.isOnCategoryPage) {
        // window.wizzyConfig['search']['configs']['pagination']['infiniteScrollOffset'] = {desktop:document.getElementsByClassName("CLP-disc")[0].offsetHeight+document.getElementsByTagName("footer")[0].offsetHeight+100000, mobile:document.getElementsByClassName("CLP-disc")[0].offsetHeight+document.getElementsByTagName("footer")[0].offsetHeight};
        window.wizzyConfig.search.configs.general.formSubmissionBehaviour =
          "redirect_page";
      } else {
        window.wizzyConfig["search"]["configs"]["pagination"][
          "infiniteScrollOffset"
        ] = { desktop: 5000, mobile: 2000 };
      }

      window.wizzyConfig.search.configs.general.formSubmissionBehaviour =
        "redirect_page";

      data.common.lazyDOMConfig.searchInputIdentifiers = [
        {
          dom: ".wizzy-search",
          type: "search",
        },
        {
          dom: ".wizzy-search-input",
          type: "search",
        },
      ];

      if (data?.common?.isOnCategoryPage) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#wizzy-shopify-collection-page-container",
        ];
      } else {
        wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#MainContent",
        ];
      }

      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push(
        ".main-content"
      );

      if (
        data?.search?.configs?.noProductsFound?.defaultPool?.data?.productsCount
      ) {
        data.search.configs.noProductsFound.defaultPool.data.productsCount = 50;
      }

      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      console.log("end of before init");
      // data['search']['configs']['sorts']['configs'].push({
      //    field:"product_wizzy-best-selling_sortOrder:float",
      //    order:"asc",
      //    label:"Best Seller"
      //  })
      // let sortLength = data['search']['configs']['sorts']['configs'].length;
      // let tempSortConfig = data['search']['configs']['sorts']['configs'][0];
      // console.log(tempSortConfig)
      // data['search']['configs']['sorts']['configs'][0] = data['search']['configs']['sorts']['configs'][sortLength - 1]
      // data['search']['configs']['sorts']['configs'][sortLength - 1] = tempSortConfig;
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      payload.attributeFacetValuesLimit = 50;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      payload.filters.attributeFacetValuesLimit = 50;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      let searchPopupContainer = document.querySelector(
        ".wizzy-search-popup-container"
      );
      let body = document.querySelector("body");
      searchPopupContainer.setAttribute("show", "false");
      body.classList.remove("wizzy-search-popup-show");

      document.querySelector(".t4s-close-overlay").click();
      // if(document.querySelector(".boost-pfs-filter-collection-header-wrapper")) document.querySelector(".boost-pfs-filter-collection-header-wrapper").style.display = "none";
      // if(document.querySelector(".CLP-disc")) document.querySelector(".CLP-disc").style.display = "none";
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if (window.collectionName && isOnCollectionPageAndFirstTimeLoaded) {
        // isOnCollectionPageAndFirstTimeLoaded = false;
        //   data.filters.sort = [{field: "product_wizzy-best-selling_sortOrder:float", order: "asc"}]
        //   window.wizzyConfig.pageStore.selectedSortMethod = { field:"product_wizzy-best-selling_sortOrder:float",
        //       order:"asc",
        //      label:"Best Seller", isSelected: true
        //    };
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // alert("Product Cached Results Rendered")
      if (window.document.documentElement.clientWidth > 768) {
        var swiper = new Swiper(".swiper-container", {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED,
    function (data) {
      document.querySelector("body").classList.remove("t4s-lock-scroll");
      document.querySelector("body").classList.remove("is--opend-drawer");
      return data;
    }
  ); //EMPTY_RESULTS_RENDERED

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (data) {
      // console.log(data);
      let header = document.querySelector("#shopify-section-header-inline");
      header && header.classList.remove("t4s-section-header");
      // alert(window.collectionName)
      if (window.collectionName) {
        document.querySelector(".header-title").innerHTML =
          window.collectionName;
      }
      // if(document.querySelector(".wizzy-collection-title")) document.querySelector(".wizzy-collection-title").innerText = window.collectionName;
      // $(".wizzy-collection-title").text(window.collectionName)
      if (typeof SmartWishlistScripts === "function") {
        SmartWishlistScripts();
      }
      // Select the element based on its class and data attributes
      var selectedElement = $(
        '.wizzy-selected-facet-list-item[data-facetkey="discountPercentage"][data-key="_gte_0_"][data-term="0"]'
      );

      // Update the label value to "No Discount"
      selectedElement &&
        selectedElement.find(".facet-item-label-value") &&
        selectedElement.find(".facet-item-label-value").text("No Discount");
      var listItem = document.querySelector(
        'li.wizzy-facet-list-item[data-key="_gte_0_"][data-term="0"]'
      );
      if (listItem) {
        listItem.querySelector(".wizzy-facet-range-list-label").innerText =
          "No Discount";
      } else {
        console.error("Element not found");
      }

      // console.log("WIZ SWIPER INITATED", $(".swiper-container"));

      if (window.document.documentElement.clientWidth > 768) {
        var swiper = new Swiper(".swiper-container", {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      }

      // console.log("WIZ SWIPER WORKING");

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (data) {
      if (window.document.documentElement.clientWidth < 768) {
        const swiper = new Swiper(".swiper-container", {
            loop: 1,
            pagination: {
              el: ".swiper-pagination",
              clickable: !0,
              type: "bullets",
            },
            autoHeight: !0,
            spaceBetween: "30",
          }),
          x = document.querySelector(".swiper").swiper;
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      console.log("Product results rendered data....", data);
      data.response.payload.facets.forEach((facet) => {
        if (Array.isArray(facet.data)) {
          facet.data.sort((a, b) => a.label.localeCompare(b.label));
        }
        if (facet.key === "discountPercentage") {
          let totalcount = facet.data.reduce(function (acc, val) {
            return (acc = acc + val.count);
          }, 0);
          let count = data.response.payload.total - totalcount;

          console.log(
            "This is count inside discount Percentage",
            totalcount,
            count
          );

          facet.data.unshift({
            label: "No Discount",
            key: 0,
            count: count,
            data: {
              start: 0,
              end: 0,
              label: "No Discount",
            },
          });
        }
      });
      try {
        setTimeout(() => {
          $(".wizzy-filters-show-results").text(
            `Show Results (${window.wizzyConfig.pageStore.searchedResponse.total})`
          );
        }, 500);
      } catch (e) {
        console.log(e);
      }
      console.log("Data in the Before Search Results Render", data);
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data.forEach((product) => {
        if (typeof product.attributes === "undefined") {
          product.attributes = [];
        }
        product.giftItem = false;
        product.newItem = false;
        product.bestSellerItem = false;
        product.attributes.forEach((attribute) => {
          if (attribute.id === "product_value_tags_front_end_tags") {
            if (
              attribute.values.some((value) => value.value.includes("Gift"))
            ) {
              product.giftItem = true;
            }
            if (
              attribute.values.some((value) =>
                value.value.includes("New-Product")
              )
            ) {
              product.newItem = true;
            }
            if (
              attribute.values.some((value) =>
                value.value.includes("Best-Seller")
              )
            ) {
              product.bestSellerItem = true;
            }
          }
        });

        if (product.price) {
          product.price = parseInt(product.price.replace(/,/g, ""), 10);
        }

        if (product.sellingPrice) {
          product.sellingPrice = parseInt(
            product.sellingPrice.replace(/,/g, ""),
            10
          );
        }

        if (product.images.length > 0)
          product.imageJSON = JSON.stringify(product.images);

        if (product.images) product.shownImages = product.images.slice(0, 4);
      });
      return data;
    }
  );
};

function moveElementById(elementId, sourceParent, targetParent) {
  var element = sourceParent.querySelector("#" + elementId);

  if (element) {
    element.parentNode.removeChild(element);
    targetParent.appendChild(element);
  } else {
    console.log("Element with ID '" + elementId + "' not found.");
  }
}

var mainElement = document.querySelector("main");
var bodyElement = document.body;

moveElementById("shopify-block-14254450603262595132", mainElement, bodyElement);

$(document).ready(function () {
  $("body").on("click", ".wizzy-common-select-overlay", function () {
    $(".wizzy-common-select-overlay, .wizzy-common-select-options").css(
      "display",
      ""
    );
  });

  $("body").on("click", ".wizzy-filters-show-results", function () {
    // alert($(".wizzy-filters-close-btn").get(0))
    setTimeout(function () {
      document.documentElement.classList.remove(
        "wizzy-overlay-opened",
        "wizzy-filters-overlay"
      );
      document.body.classList.remove(
        "wizzy-overlay-opened",
        "wizzy-filters-overlay"
      );
    }, 00);
  });

  $("body").on("input change", "#fader", function () {
    console.log("fader is working...");
    var sliderValue = $(this).val();
    sliderValue = sliderValue / 10;
    $(".wizzy-search-wrapper").attr("wizzy-tile-view-level-new", sliderValue);
  });

  // var interval;
  // $(document).on('mouseenter mouseleave', '.boost-pfs-filter-product-item-image', function (event) {
  //     console.log("Mouse Enter & Mouse Leave", event)
  //     let images = JSON.parse($(this).find(".boost-pfs-filter-product-item-image-link").attr("images"));
  //     let currentIndex = 0;

  //     if (event.type === 'mouseenter') {
  //        // console.log("Mouse Enter", event.target)
  //         // Start the interval only if it's not already running
  //         if (!interval) {
  //             interval = setInterval(() => {
  //                 console.log("Inside Interval....")
  //                 currentIndex = (currentIndex + 1) % images.length;
  //                 $(this).find('.boost-pfs-filter-product-item-flip-image').attr('src', images[currentIndex]);
  //               $(this).find('.boost-pfs-filter-product-item-flip-image').attr('srcset', images[currentIndex]);
  //             }, 500); // Change 1000 to the desired interval in milliseconds
  //         }
  //     } else {
  //         // Clear the interval when not hovering to stop the image updates
  //        console.log("Mouse Leave")
  //         clearInterval(interval);
  //         interval = null; // Reset the interval variable
  //         $(this).find('.boost-pfs-filter-product-item-flip-image').attr('src', 'default-image.jpg');
  //     }
  // });
});
